import React from "react";
import ReadIcon from "../../img/bank-icon-mail-view.png";

export const BankIconMailView = (props) => {
  const imgclassName = props?.className ? props?.className : "df-w-42";

  return (
    <>
      <img src={ReadIcon} className={imgclassName} />
    </>
  );
};
